import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { reservationPath } from 'lib/urls'
import Link from 'components/link'
import { InfoButton, LinkButton } from 'components/buttons'
import classNames from 'classnames'
import { PinkCheckmarkIcon } from 'components/icons'
import { openGiftTrackerModal } from 'registry/modals/actions'
import css from './guest-actions.scss'
import { reservationProps } from '../reservation-props'

export const BaseReservationStatusAction = ({
  reservation: { token, isPurchased, regItem, printableUrl },
  openGiftTrackerModal,
}) => (
  <>
    {isPurchased ? (
      <div
        className={classNames(
          css.guestAction,
          'h6 inline-block flex col justify-end'
        )}
      >
        <LinkButton
          className="text-bold link-info man pan"
          onClick={openGiftTrackerModal}
        >
          <PinkCheckmarkIcon /> <span>Purchased by You</span>
        </LinkButton>
        <InfoButton
          className="block mtl"
          onClick={openGiftTrackerModal}
          pill
          empty
          size="small"
        >
          Edit Gift Details
        </InfoButton>
      </div>
    ) : (
      <>
        <hr className="visible-xs-block mts mbm" style={{ width: '155px' }} />
        <div
          className={classNames(
            css.guestAction,
            'h6 inline-block flex col justify-end'
          )}
        >
          {regItem?.isFavor ? (
            <div>
              <PinkCheckmarkIcon />{' '}
              <span className="text-bold text-brand-info">Gifted By You</span>
              <InfoButton
                className="block mtm"
                empty
                pill
                size="small"
                href={printableUrl}
              >
                Download PDF
              </InfoButton>
            </div>
          ) : (
            <Link className="link-info text-bold" url={reservationPath(token)}>
              In Cart
            </Link>
          )}
        </div>
      </>
    )}
  </>
)

BaseReservationStatusAction.propTypes = {
  reservation: PropTypes.shape(reservationProps).isRequired,
  openGiftTrackerModal: PropTypes.func.isRequired,
}

export const ReservationStatusAction = connect(undefined, {
  openGiftTrackerModal,
})(BaseReservationStatusAction)
